import React, { useCallback } from 'react';
import { RefreshControl, ScrollView, TouchableHighlight, TouchableOpacity, View } from 'react-native';
import { useTheme } from '@config';
import { Header, SafeAreaView, Icon } from '@components';
import { connect, useDispatch, useSelector } from 'react-redux';
import { userClients } from '@actions';
import { useFocusEffect } from '@react-navigation/native';
import { userSelector } from '../../selectors';
import * as SplashScreen from 'expo-splash-screen';
import { Button, Text } from '../../components';
import { BaseColor, BaseStyle } from '../../config';
import { useEffect } from 'react';
import { useState } from 'react';
import { ActivityIndicator } from 'react-native';
import { Linking } from 'react-native';
import { clientActions, userActions } from '../../redux/actions';
import SinglePosition from './SinglePosition';
import { getPositionsByClient } from '../../helpers';





function Positions({ getSingleClient, getUserAuth, assignUser, getAllUser, allUser, navigation, route }) {
    const { colors } = useTheme();
    const dispatch = useDispatch();
    const user = useSelector(userSelector.user);

    const [state, setState] = useState({
        client: route.params.client,
        loading: false,
        positions:null
    });

    useFocusEffect(
        useCallback(() => {
            getUserAuth();
            onRefresh();
            return () => { };
        }, [])
    );
const onRefresh = ()=>{
    getPositionsByClient({and:{clientId:route.params?.client?.id}}, ()=>setState(s=>({...s, loading:true})), (resp)=>setState(s=>({...s, positions:resp.rows, loading:false}), ()=>setState(s=>({...s, loading:false}))));
}

    if (!user) {
        return <View></View>;
    }

    const onLayoutRootView = useCallback(async () => {
        await SplashScreen.hideAsync();
    }, []);
    const downloadFromUrl = async (name) => {
        // const filename = 'Reporting-CSV-Vorlage.csv';
        // const result = await FileSystem.downloadAsync(
        //     'http://reporting-app-daten.gate-internet.de/uploads/Reporting-CSV-Vorlage.csv',
        //     FileSystem.documentDirectory + filename
        // );
        Linking.openURL(`http://reporting-app-daten.gate-internet.de/uploads/csv/${name}.csv`);
        // save(result.uri, filename, result.headers['content-Type']);
    };

    return (
        <View style={{ flex: 1 }} onLayout={onLayoutRootView}>
            <Header
                title="Positionen"
                subTitle={`Bei ${state.client.name}`}
                //shadow
                renderLeft={() => {
                    return <Icon name="arrowleft" size={25} type="ad" color={colors.text} enableRTL={true} />;
                }}
                onPressLeft={() => {
                    navigation.goBack();
                }}
            />
            <SafeAreaView style={BaseStyle.safeAreaView} edges={['right', 'left', "bottom"]}>
                <ScrollView
                refreshControl={
                                            <RefreshControl colors={[colors.primary]} tintColor={colors.primary} refreshing={false} onRefresh={onRefresh} />
                                        }
                >
                    <View style={{paddingBottom:100 }}>
                        {state.loading? 
                        <View>
                            <ActivityIndicator size={'large'} color={BaseColor.primary} />
                        </View>
                        
                        :(state.positions?.length ==0 )? (
                            <View style={{flex:1, alignItems:'center', justifyContent:'center', padding:50}}>
                                <Text headline grayColor style={{textAlign:'center'}}>Keine Positionen bei {state.client.name} momentan</Text>
                            </View>
                        ) : (
                            state.positions
                                ?.map((position, index) => (
                                    <SinglePosition key={`position${index}`} position={position} navigation={navigation} 
                                    onPositionDeleted={()=>setState(s=>({...s,  positions: s.positions.filter(pos=>pos.id!=position.id)}))}
                                    onPositionEdited={(newPosition)=>setState(s=>({...s, positions: s.positions.map(pos=>pos.id==position.id?newPosition:pos)}))}
                                    />
                                ))
                        )}
                    </View>
                </ScrollView>
                <View style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                    <View style={{ padding: 15, alignItems: 'center', justifyContent: 'center' }}>
                                        <Button
                                            style={{ height: 40, backgroundColor: 'white' }}
                                            textColor={'black'}
                                            icon={<Icon name="plus" size={25} type="ad" color={BaseColor.primary} />}
                                            onPress={() => navigation.navigate('CreatePosition', {clientId:state.client.id, clientName: state.client.name, onCreated:(newPosition)=>setState(s=>({...s, positions: [...(s.positions??[]), newPosition ]}))})}
                                        >
                                            {' '}
                                            Position anlegen
                                        </Button>
                                    </View>
                                </View>
            </SafeAreaView>
        </View>
    );
}

const menuIcon = {
    width: 60,
    height: 60,
    borderRadius: 50,
    shadowColor: '#000',
    shadowOffset: {
        width: 0,
        height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 20,
    alignItems: 'center',
    justifyContent: 'center',
};
function mapState(state) {
    const { user, all } = state.users;
    return { user, allUser: all };
}

const actionCreators = {
    getSingleClient: clientActions.getSingle,
    getUserAuth: userActions.getUserAuth,
};

export default connect(mapState, actionCreators)(Positions);
